import * as React from 'react';

import { DimeDropdownMenuContent } from '../DimeDropdownMenu.js';
import { MenuItemSelectContext } from '../lib/menu-item-select-context.js';

type DimeActionToolbarMenuContentProps = Readonly<
  Omit<React.ComponentProps<typeof DimeDropdownMenuContent>, 'onCloseAutoFocus'> & {
    /** Radix's menu content honours this at runtime but leaves it off `DropdownMenuContentProps`. */
    onOpenAutoFocus?: (event: Event) => void;
  }
>;

/** After an item select, the closing menu keeps its hands off focus so a dialog the item opened keeps its first field focused. */
export function DimeActionToolbarMenuContent({
  children,
  ...props
}: DimeActionToolbarMenuContentProps) {
  const itemSelected = React.useRef(false);
  const itemSelect = React.useMemo(
    () => ({
      markItemSelected: () => {
        itemSelected.current = true;
      },
      isItemSelected: () => itemSelected.current,
    }),
    [],
  );
  const onCloseAutoFocus = (event: Event) => {
    if (itemSelected.current) event.preventDefault();
    itemSelected.current = false;
  };

  return (
    <DimeDropdownMenuContent {...props} onCloseAutoFocus={onCloseAutoFocus}>
      <MenuItemSelectContext.Provider value={itemSelect}>{children}</MenuItemSelectContext.Provider>
    </DimeDropdownMenuContent>
  );
}
